import {
  AiAnalyticsSummaryPageType,
  AnalyticsData,
} from "@redotech/redo-model/conversion/ai-analytics-summary";
import * as z from "zod/v4";

export const generateAiAnalyticsSummary = {
  name: "generateAiAnalyticsSummary" as const,
  input: z.object({
    pageType: AiAnalyticsSummaryPageType,
    analyticsData: AnalyticsData,
  }),
  output: z.object({ summary: z.string() }),
};
